/**
 * Sends legacy unprefixed marketing URLs to /es or /en.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useParams, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { localizePath } from '../i18n/localePaths';

const LegacyLocaleRedirect = ({ to }) => {
  const { lang } = useLanguage();
  const location = useLocation();
  return (
    <Navigate
      to={`${localizePath(to, lang)}${location.search}${location.hash}`}
      replace
    />
  );
};

LegacyLocaleRedirect.propTypes = {
  to: PropTypes.string.isRequired,
};

/**
 * /blog/:slug without locale → /{lang}/blog/:slug
 */
export const LegacyBlogRedirect = () => {
  const { slug } = useParams();
  const { lang } = useLanguage();
  const location = useLocation();
  return (
    <Navigate
      to={`${localizePath(`/blog/${slug}`, lang)}${location.search}${location.hash}`}
      replace
    />
  );
};

export default LegacyLocaleRedirect;
